import { css } from 'styled-components';
import { CFBaseLinkHelpers } from './styles';
export const CFBaseLinkStyles = {
    Root: css `
    ${CFBaseLinkHelpers.rootStyles};
    ${CFBaseLinkHelpers.rootHover};
  `,
};
